import styled, { css } from "styled-components";
import { fonts } from "assets/fontStyles";
import colours from "assets/colours";
import queries, { devices } from "utils/responsivenessHelper";

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3em 2.5em 4em 2.5em;
  min-height: 383.31px;
  justify-content: center;

  width: 542px;
  height: 385px;

  ${queries.portrait({ padding: "3em 1em", minHeight: "65vh" }, devices.phone)}
  ${queries.landscape({ minHeight: "80vh" }, devices.phone)}

  ${queries.both({ width: "100%" }, devices.phone)}


  ${({ uploaded }) =>
    !uploaded &&
    css`
      cursor: pointer;
    `}

    ${({ image }) =>
      image &&
      css`
        padding: 0em 2.5em 0em 2.5em;
      `}
`;

const Icon = styled.img`
  width: 60px;
  height: 60px;
  display: flex;
  margin: 0 auto;
  margin-bottom: 10px;
`;

const DropZoneText = styled.div`
  ${fonts.heading3};
  min-height: 2.65em;
  min-width: 11.5em;
  white-space: pre-wrap;
  text-align: center;

  ${({ uploaded }) =>
    uploaded &&
    css`
      min-width: 11em;
      max-width: 11em;
      white-space: normal;
      margin: 0.75em 0em 1.25em 0em;
    `}

  span {
    color: ${colours.zltoLightBlue};
  }

  ${queries.portrait({ minWidth: "100%", whiteSpace: "normal" }, devices.phone)}
`;

const ImageWrapper = styled.div`
  width: 300px;
  height: 300px;
  position: relative;
  margin-bottom: 25px;

  ${queries.both({
    width: 250,
    height: 250,
  })};
`;

const Image = styled.div`
  border-radius: 100%;
  overflow: hidden;
  border-radius: 50%;
  width: 300px;
  height: 300px;
  box-shadow: 0px 2px 5px rgba(206, 210, 227, 0.3);
  background-image: url(${(props) => props.src});
  background-size: cover;
  background-position: center;

  ${queries.both({
    width: 250,
    height: 250,
  })};
`;

export { Content, Icon, DropZoneText, ImageWrapper, Image };
